import React from 'react';
import { View, Image, StyleSheet, TouchableOpacity, Platform, Dimensions } from 'react-native';
import { COLORS } from '../theme/themeTokens';

interface DashboardHeaderProps {
    onNavigate?: (screen: string) => void;
    hasUnreadNotifications?: boolean;
    /**
     * 'dashboard' — прозрачный фон + Background.png за хедером (для DashboardV2Screen)
     * 'solid'     — обычный тёмный фон headerBackground (для остальных экранов)
     * По умолчанию 'solid'
     */
    variant?: 'dashboard' | 'solid';
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
    onNavigate,
    hasUnreadNotifications,
    variant = 'solid',
}) => {
    const statusBarHeight = Platform.OS === 'android' ? 28 : 20;

    const handleNavigate = (screen: string) => {
        onNavigate?.(screen);
    };

    const headerContent = (
        <View style={styles.headerRow}>
            <TouchableOpacity
                onPress={() => handleNavigate('profile')}
                style={styles.headerIconBtn}
                activeOpacity={0.7}
            >
                <Image
                    source={require('../assets/logo_white.png')}
                    style={styles.headerLogo}
                    resizeMode="contain"
                />
            </TouchableOpacity>
            <View style={styles.headerRightGroup}>
                <TouchableOpacity
                    onPress={() => handleNavigate('notifications')}
                    style={styles.headerIconBtn}
                    accessibilityRole="button"
                    accessibilityLabel="Notifications"
                >
                    {Platform.OS === 'ios' ? (
                        <Image
                            source={
                                hasUnreadNotifications
                                    ? require('../assets/bellnew.png')
                                    : require('../assets/bell.png')
                            }
                            style={[styles.headerIcon, hasUnreadNotifications && { tintColor: undefined }]}
                            resizeMode="contain"
                        />
                    ) : (
                        <View style={styles.bellWrapper}>
                            <Image
                                source={require('../assets/bell.png')}
                                style={styles.headerIcon}
                                resizeMode="contain"
                            />
                            {hasUnreadNotifications && (
                                <View style={styles.bellDot} />
                            )}
                        </View>
                    )}
                </TouchableOpacity>
                {/* Orders moved to the Orders tab of the history screen. */}
                {/* Settings (gear) icon hidden — Profile теперь открывается кликом по логотипу слева.
                <TouchableOpacity
                    onPress={() => handleNavigate('profile')}
                    style={styles.headerIconBtn}
                >
                    <Image
                        source={require('../assets/settings.png')}
                        style={styles.headerIcon}
                        resizeMode="contain"
                    />
                </TouchableOpacity>
                */}
            </View>
        </View>
    );

    if (variant === 'dashboard') {
        return (
            <View style={[styles.fixedHeader, { paddingTop: statusBarHeight }]}>
                {headerContent}
            </View>
        );
    }

    // variant === 'solid'
    return (
        <View style={[styles.headerBackground, { paddingTop: statusBarHeight }]}>
            {headerContent}
        </View>
    );
};

const styles = StyleSheet.create({
    fixedHeader: {
        backgroundColor: 'transparent',
        paddingBottom: 10,
    },
    // variant='solid'
    headerBackground: {
        backgroundColor: COLORS.primaryNavy,
        paddingBottom: 10,
    },
    headerRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 20,
        marginTop: -10,
    },
    headerIconBtn: {
        height: 40,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 4,
    },
    headerLogo: {
        width: 100,
        height: 28,
    },
    headerRightGroup: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    headerIcon: {
        width: 28,
        height: 28,
        tintColor: COLORS.white,
    },
    bellWrapper: {
        width: 28,
        height: 28,
        overflow: 'visible',
    },
    bellDot: {
        position: 'absolute',
        top: 0,
        right: 0,
        width: 9,
        height: 9,
        borderRadius: 5,
        backgroundColor: '#FF3B30',
        borderWidth: 1.5,
        borderColor: COLORS.primaryNavy,
        zIndex: 10,
        elevation: 10,
    },
});

export default DashboardHeader;
